import React from 'react';
import { useSelector } from 'react-redux';

import { useActionDispatcher } from '../../../hooks';
import { saveCurrentUserRequest } from '../../../store/modules/users/actions';
import { selectCurrentUser } from '../../../store/modules/users/selectors';
import { FormUserNotifications } from '../../../components';

const CurrentUserNotifications = () => {
  const user = useSelector(selectCurrentUser);
  const saveCurrentUser = useActionDispatcher(saveCurrentUserRequest);

  return (
    <FormUserNotifications
      currentMode
      record={user}
      onSubmit={saveCurrentUser}
      preventCancelChanges
      showPrivateFields
    />
  );
};

export default CurrentUserNotifications;
